/**
 * Canonical normalizer for search query strings.
 *
 * Used everywhere we need to dedupe queries across heterogeneous sources
 * (session recents, DB recents, top site-wide, live AI/log suggestions). Two
 * queries that differ only in casing, surrounding whitespace, internal
 * whitespace runs, or trailing punctuation must collapse to the same key.
 *
 * Mirrors the database `normalized_query` column closely enough to be safe
 * for client-side dedup without re-querying.
 */
export function normalizeQuery(input: string): string {
  return (input || "")
    .toLowerCase()
    .replace(/\s+/g, " ")
    .replace(/[?.!\u2026]+$/g, "") // strip trailing ?, ., !, …
    .trim();
}
